import { Observable } from 'rxjs';
import { ChatEngineHandle } from '../chat-model.interface';

export abstract class ChatEngineLifeСycleService {
  public abstract initEngine(accessToken: string): void;
  public abstract destroyEngine(): void;

  public abstract get engineReadinessChanged(): Observable<ChatEngineHandle>;
  public abstract get connectionStatusChanged(): Observable<boolean>;
  public abstract get expiredToken(): Observable<void>;
}
